import { render, staticRenderFns } from "./account-org.vue?vue&type=template&id=570aa8e2&scoped=true&"
import script from "./account-org.vue?vue&type=script&lang=js&"
export * from "./account-org.vue?vue&type=script&lang=js&"
import style0 from "./account-org.vue?vue&type=style&index=0&id=570aa8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570aa8e2",
  null
  
)

export default component.exports